import { IconNames } from '@blueprintjs/icons';
import { ActionButtonText } from '@strata/react-buttons';
import classNames from 'classnames';
import { FieldArray, getIn, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { useState } from 'react';

import { CardControls } from 'pages/homeScreenMessaging/CardControls';
import { DeleteCardDialog } from 'pages/homeScreenMessaging/dialogs/DeleteCardDialog';

const Card = ({
    title,
    arrayHelpers,
    index = undefined,
    readOnly = undefined,
    onDeleteClick = undefined,
    className = undefined,
    children,
}) => (
    <div className={classNames('sds_card-array__card', className)}>
        <div className="sds_card-array__header">
            <span>{`${title} ${index + 1}`}</span>
            {!readOnly && (
                <CardControls
                    arrayHelpers={arrayHelpers}
                    index={index}
                    onDeleteClick={onDeleteClick}
                />
            )}
        </div>
        {children({ name: `${arrayHelpers.name}.${index}`, readOnly, index })}
    </div>
);

Card.propTypes = {
    title: PropTypes.string.isRequired,
    arrayHelpers: PropTypes.shape({ name: PropTypes.string.isRequired }).isRequired,
    index: PropTypes.number,
    readOnly: PropTypes.bool,
    onDeleteClick: PropTypes.func,
    className: PropTypes.string,
    children: PropTypes.func.isRequired,
};

export const CardArray = ({
    name,
    title,
    deleteDialogBodyText,
    newArrayValue = undefined,
    readOnly = undefined,
    cardClassName = undefined,
    children,
}) => {
    const formik = useFormikContext();
    const [indexToDelete, setIndexToDelete] = useState();

    return (
        <FieldArray name={name}>
            {(arrayHelpers) => (
                <>
                    <div className="sds_card-array__header">
                        <span>{`${title}(s)`}</span>
                        {!readOnly && (
                            <ActionButtonText
                                label={`Add ${title}`}
                                leftIcon={IconNames.ADD}
                                onClick={() => arrayHelpers.push(newArrayValue)}
                            />
                        )}
                    </div>
                    <DeleteCardDialog
                        title={title}
                        bodyText={deleteDialogBodyText}
                        indexToDelete={indexToDelete}
                        onClose={() => setIndexToDelete()}
                        arrayHelpers={arrayHelpers}
                        cardComponent={
                            <Card
                                title={title}
                                className={cardClassName}
                                arrayHelpers={arrayHelpers}
                                index={indexToDelete}
                                readOnly
                            >
                                {children}
                            </Card>
                        }
                    />
                    {getIn(formik.values, arrayHelpers.name)?.map((_section, index) => (
                        <Card
                            // eslint-disable-next-line react/no-array-index-key
                            key={index}
                            title={title}
                            className={cardClassName}
                            arrayHelpers={arrayHelpers}
                            index={index}
                            readOnly={readOnly}
                            onDeleteClick={() => setIndexToDelete(index)}
                        >
                            {children}
                        </Card>
                    ))}
                </>
            )}
        </FieldArray>
    );
};

CardArray.propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    deleteDialogBodyText: PropTypes.string.isRequired,
    newArrayValue: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.bool,
        PropTypes.array,
        PropTypes.object,
    ]),
    readOnly: PropTypes.bool,
    cardClassName: PropTypes.string,
    children: PropTypes.func.isRequired,
};
